
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import "rxjs/Rx";

import { environment } from '../../environments/environment';

import { Baseservice } from './baseservice'

import { AuthenticationService } from './authentication.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class RunMaintenanceTasksService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super("run-maintenance", http, authentication);
  }

  synchronizeAllAccounts() {
    return this.http.get(this.url + "/" + "tasks");
  }
}
